import { useTranslation } from "react-i18next";

// `showTopLine` draws the line that normally hangs down into the story from
// the interlude above it — for when the couple turned the interlude off. It
// sits above the container (z-index 5), whose gradient reaches up over it.
const StorySlider = ({ id, slides, showTopLine = false, ...rest }) => {
  const { t } = useTranslation();
  const storySlides = slides && slides.length > 0 ? slides : [];

  return (
    <section id={id} className="section topless story" {...rest}>
      {showTopLine && (
        <div
          className="vert-line mbm-exclusion"
          style={{ position: "relative", zIndex: 6 }}
        ></div>
      )}
      <div
        data-w-id="ad522073-bfb7-f992-882a-00ffdbbbdfde"
        className="container story"
      >
        <div className="arc-header-div no-max story">
          <h2 className="heading-9vw m-14">{t("story.heading")}</h2>
        </div>

        <div className="top-reversed-gradiant"></div>

        <div
          data-delay="4000"
          data-animation="slide"
          className="story-slider w-slider"
          data-autoplay="false"
          data-easing="ease-out-cubic"
          data-hide-arrows="false"
          data-disable-swipe="false"
          data-autoplay-limit="0"
          data-nav-spacing="3"
          data-duration="800"
          data-infinite="true"
        >
          <div className="w-slider-mask">
            {storySlides.map((slide, index) => (
              <div key={index} className="story-slide w-slide">
                <div className="slide-flex-wrap">
                  <div className="slider-im-div">
                    <img
                      src={slide.image}
                      loading="lazy"
                      alt={slide.alt}
                      className="full-im"
                    />
                  </div>
                  <div className="arc-frame-wrap">
                    <div className="p-wrap histoire">
                      <div className="year-div mbm-exclusion mid">
                        <h2 className="year-txt small">{slide.year}</h2>
                      </div>
                      <div className="story-par-div">
                        <p className="made-28">{slide.title}</p>
                        <p className="body-16">{slide.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="left-arrow-2 w-slider-arrow-left">
            <img
              src="/assets/photos/Slider-Arrow-2.svg"
              alt={t("story.arrowAlt")}
              loading="lazy"
              className="slider-arrow _180"
            />
          </div>
          <div className="right-arrow-2 w-slider-arrow-right">
            <img
              src="/assets/photos/Slider-Arrow-2.svg"
              alt={t("story.arrowAlt")}
              loading="lazy"
              className="slider-arrow"
            />
          </div>
          <div className="slide-nav-hidden w-slider-nav w-round"></div>
        </div>
      </div>
    </section>
  );
};

export default StorySlider;
